import { lazy } from 'react';

const SectorView = lazy(() => import('./SectorView'));

export default SectorView;
